/**
 * GLSL to generate a texture containing only selection highlights.
 * @module
 */
import {
  entityIdHighlightDeclarationsFragment,
  entityIdHighlightDeclarationsVertex,
  entityIdHighlightVertexHighlightOnly,
} from "./entityIdHighlight";

export const highlightOnlyVertexShader = `
#include <clipping_planes_pars_vertex>

${entityIdHighlightDeclarationsVertex}

void main() {
  #include <begin_vertex>
  #include <project_vertex>
  // TODO: We could also include support for morph targets and skinning in case we ever need them.
  #include <clipping_planes_vertex>

  ${entityIdHighlightVertexHighlightOnly}
}
`;

export const highlightOnlyFragmentShader = `
varying vec4 vId;

${entityIdHighlightDeclarationsFragment}

#include <clipping_planes_pars_fragment>

void main() {
  #include <clipping_planes_fragment>

  gl_FragColor = vec4(1, 1, 1, 1);

  gl_FragColor.rgb = mix(gl_FragColor.rgb, vEntitySelectionColor.rgb, vEntitySelectionColor.a);
}
`;
